import { createSlice } from "@reduxjs/toolkit";
import {
  createEmployeeId,
  createUserDetails,
  getDropDownList,
  downloadBulkTemplate,
  uploadBulkFile,
  getPeopleDetails,
  getuserDetails,
  saveUserAsDraft,
  searchUserDetails,
  updateBankDetails,
  updateUserDetails,
  uploadFileWithPresignedUrl,
  bulkUpdateWithPresignedUrl,
} from "./thunk";

const initialState = {
  peopleDetails: null,
  peopleDetailsStatus: null,
  searchList: null,
  searchListStatus: null,
  userDetails: null,
  userDetailsStatus: null,
  addEmployeeDetails: {
    user_details: {
      education: [
        {
          university_name: null,
          educational_category: null,
          education_degree: null,
          field_of_specualisation: null,
          course_type: null,
          gpa: null,
          start_date: null,
          end_date: null,
        },
      ],
      job_history: [
        {
          company_name: null,
          job_title: null,
          job_location: null,
          job_summary: null,
          start_date: null,
          end_date: null,
          current_check: false,
        },
      ],
    },
    bank_details: {},
  },
  isEdit: false,
  isDraft: false,
  createUser: null,
  createUserStatus: null,
  employeeId: null,
  employeeIdStatus: null,
  draftData: null,
  draftDataStatus: null,
  updateUserDetailsResponse: null,
  updateUserDetailsStatus: null,
  updateBankDetailsResponse: null,
  updateBankDetailsStatus: null,
  fileUploadResponse: null,
  fileUploadStatus: null,
  dropDownListResponse: null,
  dropDownListStatus: null,
  downloadBulkTemplateResponse: null,
  downloadBulkTemplateResponseStatus: null,
  uploadBulkFileResponse: null,
  uploadBulkFileResponseStatus: null,
  bulkUpdateUsersResponse: null,
  bulkUpdateUsersResponseStatus: null,
};

const peopleSlice = createSlice({
  name: "people",
  initialState: initialState,
  reducers: {
    resetPeopleDetails: (state, action) => {
      state.peopleDetails = null;
      state.peopleDetailsStatus = null;
    },
    resetUserDetails: (state) => {
      state.userDetails = null;
      state.userDetailsStatus = null;
    },
    resetSearchList: (state) => {
      state.searchList = null;
      state.searchListStatus = null;
    },
    updateEdit: (state, action) => {
      state.isEdit = action.payload;
    },
    updateDraft: (state, action) => {
      state.isDraft = action.payload;
    },
    resetEmployeeResponse: (state, action) => {
      state.employeeId = null;
      state.employeeIdStatus = null;
    },
    resetCreateUserResponse: (state, action) => {
      state.createUser = null;
      state.createUserStatus = null;
    },
    resetDratfDataResponse: (state, action) => {
      state.draftData = null;
      state.draftDataStatus = null;
    },
    resetUpdateUserDataResponse: (state, action) => {
      state.updateUserDetailsResponse = null;
      state.updateUserDetailsStatus = null;
    },
    resetUpdateBankDataResponse: (state, action) => {
      state.updateBankDetailsResponse = null;
      state.updateBankDetailsStatus = null;
    },
    resetUserDetailsStatus: (state, action) => {
      state.userDetailsStatus = null;
    },
    resetUserDetailsData: (state, action) => {
      state.userDetails = null;
    },
    resetBulkUpdateUserResponse: (state, action) => {
      state.bulkUpdateUsersResponse = null;
      state.bulkUpdateUsersResponseStatus = null;
    },
    setInitialState: (state) => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getPeopleDetails.pending, (state, action) => {
      state.peopleDetails = null;
      state.peopleDetailsStatus = "PENDING";
    });
    builder.addCase(getPeopleDetails.rejected, (state, action) => {
      state.peopleDetails = action.payload;
      state.peopleDetailsStatus = "ERROR";
    });
    builder.addCase(getPeopleDetails.fulfilled, (state, action) => {
      state.peopleDetails = action.payload;
      state.peopleDetailsStatus = "SUCCESS";
    });

    builder.addCase(getuserDetails.pending, (state, action) => {
      state.userDetails = null;
      state.userDetailsStatus = "PENDING";
    });
    builder.addCase(getuserDetails.rejected, (state, action) => {
      state.userDetails = action.payload;
      state.userDetailsStatus = "ERROR";
    });
    builder.addCase(getuserDetails.fulfilled, (state, action) => {
      state.userDetails = action.payload;
      state.userDetailsStatus = "SUCCESS";
    });

    builder.addCase(searchUserDetails.pending, (state, action) => {
      state.searchList = null;
      state.searchListStatus = "PENDING";
    });
    builder.addCase(searchUserDetails.rejected, (state, action) => {
      state.searchList = action.payload;
      state.searchListStatus = "ERROR";
    });
    builder.addCase(searchUserDetails.fulfilled, (state, action) => {
      state.searchList = action.payload;
      state.searchListStatus = "SUCCESS";
    });

    builder.addCase(createUserDetails.pending, (state, action) => {
      state.createUser = null;
      state.createUserStatus = "PENDING";
    });
    builder.addCase(createUserDetails.rejected, (state, action) => {
      state.createUser = action.payload;
      state.createUserStatus = "ERROR";
    });
    builder.addCase(createUserDetails.fulfilled, (state, action) => {
      state.createUser = action.payload;
      state.createUserStatus = "SUCCESS";
    });

    builder.addCase(createEmployeeId.pending, (state, action) => {
      state.employeeId = null;
      state.employeeIdStatus = "PENDING";
    });
    builder.addCase(createEmployeeId.rejected, (state, action) => {
      state.employeeId = action.payload;
      state.employeeIdStatus = "ERROR";
    });
    builder.addCase(createEmployeeId.fulfilled, (state, action) => {
      state.employeeId = action.payload;
      state.employeeIdStatus = "SUCCESS";
    });

    builder.addCase(saveUserAsDraft.pending, (state, action) => {
      state.draftData = null;
      state.draftDataStatus = "PENDING";
    });
    builder.addCase(saveUserAsDraft.rejected, (state, action) => {
      state.draftData = action.payload;
      state.draftDataStatus = "ERROR";
    });
    builder.addCase(saveUserAsDraft.fulfilled, (state, action) => {
      state.draftData = action.payload;
      state.draftDataStatus = "SUCCESS";
    });

    builder.addCase(updateUserDetails.pending, (state, action) => {
      state.updateUserDetailsResponse = null;
      state.updateUserDetailsStatus = "PENDING";
    });
    builder.addCase(updateUserDetails.rejected, (state, action) => {
      state.updateUserDetailsResponse = action.payload;
      state.updateUserDetailsStatus = "ERROR";
    });
    builder.addCase(updateUserDetails.fulfilled, (state, action) => {
      state.updateUserDetailsResponse = action.payload;
      state.updateUserDetailsStatus = "SUCCESS";
    });

    builder.addCase(updateBankDetails.pending, (state, action) => {
      state.updateBankDetailsResponse = null;
      state.updateBankDetailsStatus = "PENDING";
    });
    builder.addCase(updateBankDetails.rejected, (state, action) => {
      state.updateBankDetailsResponse = action.payload;
      state.updateBankDetailsStatus = "ERROR";
    });
    builder.addCase(updateBankDetails.fulfilled, (state, action) => {
      state.updateBankDetailsResponse = action.payload;
      state.updateBankDetailsStatus = "SUCCESS";
    });

    builder.addCase(uploadFileWithPresignedUrl.pending, (state, action) => {
      state.fileUploadResponse = null;
      state.fileUploadStatus = "PENDING";
    });
    builder.addCase(uploadFileWithPresignedUrl.rejected, (state, action) => {
      state.fileUploadResponse = action.payload;
      state.fileUploadStatus = "ERROR";
    });
    builder.addCase(uploadFileWithPresignedUrl.fulfilled, (state, action) => {
      state.fileUploadResponse = action.payload;
      state.fileUploadStatus = "SUCCESS";
    });

    builder.addCase(getDropDownList.pending, (state, action) => {
      state.dropDownListResponse = null;
      state.dropDownListStatus = "PENDING";
    });
    builder.addCase(getDropDownList.rejected, (state, action) => {
      state.dropDownListResponse = action.payload;
      state.dropDownListStatus = "ERROR";
    });
    builder.addCase(getDropDownList.fulfilled, (state, action) => {
      state.dropDownListResponse = action.payload;
      state.dropDownListStatus = "SUCCESS";
    });
    builder.addCase(downloadBulkTemplate.pending, (state, action) => {
      state.dropDownListResponse = null;
      state.dropDownListStatus = "PENDING";
    });
    builder.addCase(downloadBulkTemplate.rejected, (state, action) => {
      state.dropDownListResponse = action.payload;
      state.dropDownListStatus = "ERROR";
    });
    builder.addCase(downloadBulkTemplate.fulfilled, (state, action) => {
      state.dropDownListResponse = action.payload;
      state.dropDownListStatus = "SUCCESS";
    });
    builder.addCase(bulkUpdateWithPresignedUrl.pending, (state, action) => {
      state.bulkUpdateUsersResponse = null;
      state.bulkUpdateUsersResponseStatus = "PENDING";
    });
    builder.addCase(bulkUpdateWithPresignedUrl.rejected, (state, action) => {
      state.bulkUpdateUsersResponse = action.payload;
      state.bulkUpdateUsersResponseStatus = "ERROR";
    });
    builder.addCase(bulkUpdateWithPresignedUrl.fulfilled, (state, action) => {
      state.bulkUpdateUsersResponse = action.payload;
      state.bulkUpdateUsersResponseStatus = "SUCCESS";
    });
  },
});

export const peopleActions = peopleSlice.actions;

export default peopleSlice.reducer;
